import React from 'react';
import s from './styles.module.css'
import Wrapper from "../../components/wrapper";
import HeaderTitle from "../../components/header_title";

const About = () => {
  return (
    <div className={s.main}>
      <Wrapper>
        <HeaderTitle/>
        <h1>О проекте</h1>
        <p className={s.text}>Это информационный сайт, который публикует материалы о кредитах, финансовых продуктах и финансовой грамотности.</p>
        <p className={s.text}>Чтобы посмотреть предложения по займам - перейдите на главную страницу.</p>
        <p className={s.text}>Сайт не осуществляет выдачу кредитов и займов.</p>
        <p className={s.text}>Сайт не является банком, кредитной организацией, кредитором или финансовым посредником.</p>
        <p className={s.text}>Здесь собраны максимально выгодные предложения с удобными фильтрами.</p>
        <p className={s.text}>Материалы сайта не являются финансовой консультацией, персональной рекомендацией или предложением оформить кредит.</p>
        <p className={s.text}>Мы работаем на благо клиента и не берем с пользователей деньги.</p>
        <p className={s.text}>Все рекомендуемые на сайте кредитные учреждения имеют соответствующие лицензии.</p>
        <p className={s.text}>
          {/*<div><b>samzaim.ru</b></div>*/}
          {/*<div>Бондаренко Михаил Николаевич. Беларусь, Гомельская область, Калинковичи, улица 40 лет Победы, 34.</div>*/}
          {/*<div>email: admin@samzaim.ru, ИНН: EB1199290, телефон: +375 293398694</div>*/}
        </p>
      </Wrapper>
    </div>
  );
};

export default About;
